export const ChartTooltip = ({ active, payload, label, formatter, labelFormatter }) => {
  if (!active || !payload || !payload.length) return null;
  return (
    <div className="rounded-lg px-3 py-2 bg-popover/95 border border-border/70 text-foreground shadow-[0_10px_30px_rgba(0,0,0,0.45)] text-xs min-w-[150px]">
      <div className="font-semibold mb-1.5 text-sm">{labelFormatter ? labelFormatter(label, payload) : label}</div>
      <div className="space-y-1">
        {payload
          .filter((p) => p.value !== null && p.value !== undefined)
          .map((p) => {
            const [val, name] = formatter ? formatter(p.value, p.name, p) : [p.value, p.name];
            return (
              <div key={p.dataKey || p.name} className="flex items-center justify-between gap-4">
                <span className="flex items-center gap-1.5 text-muted-foreground">
                  <span className="inline-block h-2 w-2 rounded-sm" style={{ background: p.color || p.fill }} />
                  {name}
                </span>
                <span className="font-mono tabular">{val}</span>
              </div>
            );
          })}
      </div>
    </div>
  );
};
